import type * as z from 'zod';

import { booleanMutationSchema } from '@/_schemas/generic';

import { paymentMethodQuerySchema } from './payment-method-query-schema';

export const paymentMethodUpdateSchema = paymentMethodQuerySchema.pick({ id: true, name: true }).extend({
  is_active: booleanMutationSchema(),
  include_for_taking_tender: booleanMutationSchema(),
  include_for_manual_deposit: booleanMutationSchema(),
});
export type PaymentMethodUpdateSchema = z.infer<typeof paymentMethodUpdateSchema>;

export const paymentMethodCreateSchema = paymentMethodUpdateSchema.omit({ id: true });
export type PaymentMethodCreateSchema = z.infer<typeof paymentMethodCreateSchema>;
